<template>
  <div class="article-frame">
    <div class="article-box">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/pc_banner_privacy.jpeg`)">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          プライバシーポリシー
        </h1>
        <h2 class="update-time">
          最終更新日：2023年11月24日
        </h2>
        <h3 class="terms-title">
          勝winのウェブサイトをご利用になる前に、以下のポリシーをお読みください：
        </h3>

        <ol class="terms-list">
          <li>
            当サイトを利用するお客様(以下、お客様といいます。)は、当サイトのご利用または当サイトに登録することにより、このプライバシーポリシーの条項に同意し、受諾したものとみなされます。
          </li>
          <li>お客様が本ポリシーに同意されない場合は、サイトのご利用を中止してください。</li>
          <li>当サイトは、本ポリシーを変更する権利を有します。</li>
          <li>変更は当サイトに掲載された後に実施されます。</li>
        </ol>
        <p class="content-p-text">
          勝winhはお客様の個人情報の取り扱いに関して、当サイトが事業を展開している国/地域のデータ保護法および規制に準拠していることを保証します。よって、当サイトはお客様の個人情報の取り扱いについて、このプライバシーポリシーを定めます。
        </p>
        <p class="content-p-text">
          当サイトではプライバシーポリシーを随時更新する場合があるため、当サイトはお客様にプライバシーポリシーを定期的に確認することをお勧めします。
        </p>
        <p class="content-p-text">
          当サイトがプライバシーポリシーを大幅に変更する場合、当サイトは変更内容をお客様に通知します。
        </p>
        <p class="content-p-text">
          当サイトはお客様の個人情報を重要視しており、以下の方針に基づいて事業運営を行い、社会的責任を果たしてまいります。
        </p>
        <p class="content-p-text">
          勝winは、当サイトへのアカウント登録時にお客様から入手した個人情報(氏名、電話番号、メールアドレス、住所、生年月日など)を第三者に提供・開示することはございません。
        </p>
        <p class="content-p-text">
          勝winでは、お客様の個人情報を保護するためにSSL(Secure Socket
          Layer)セキュリティシステムを採用しております。お客様が入力された氏名、住所、電話番号、勝敗結果、
        </p>
        <p class="content-p-text">
          入出金金額などの個人情報は、SSLにより自動的に暗号化し送受信され、外部の第三者によるお客様の個人情報取得を防止します。当サイトは、お客様に安心してご利用いただけるよう、お客様の個人情報の保護に最大限の努力をいたします。
        </p>
        <p class="content-p-text">
          【当サイトにおける個人情報の収集方法】関連注意事項
        </p>
        <p class="content-p-text">
          当サイトに登録しアカウントを開設するには、お客様がウェブサイトやモバイルなどアプリで操作できるように、個人情報の提供を求められます。
        </p>
        <p class="content-p-text">
          お客様は当サイトに個人情報を提供する義務はございませんが、当サイトがお客様にサービスを提供するため（例えば、お客様が当サイトでゲームをプレイできるようにするため）、
        </p>
        <p class="content-p-text">
          および当サイトでのサービスを提供するためには、特定の個人情報が必要となります。お客様が当サイトで必要な情報を提供しないことを選択される場合、特定のサービスを受けることができない場合がございます。
        </p>
        <p class="content-p-text">
          当サイトでは、支払い時にご利用のカードの詳細を含む取引情報も収集いたします。など当サイトでは、当サイトまたは当サイトが委託する会社が実施するアンケートを通じて個人情報を収集する場合がございます。さらに、
        </p>
        <p class="content-p-text">
          当サイトはお客様によるサイト、モバイルアプリおよびサービスの使用に関する情報を収集いたします。
        </p>
        <p class="content-p-text">
          当サイトは、プライバシーポリシーに記載されている目的で、お客様の個人情報を処理するために必要なその他の情報も収集いたします
        </p>
        <p class="content-p-text">
          お客様が当サイトのウェブサイト公開領域にお客様の氏名、住所、またはその他の個人情報を提供された場合、当サイトはこれらの個人情報を使用いたします。
        </p>
        <p class="content-p-text">
          当サイトは、サードパーティのサービスプロバイダーなど(セキュリティ関連会社など)などから個人情報を収集する場合もあります。
        </p>
        <p class="content-p-text">
          最後に、当サイトでは「cookie」を使用しお客様のデバイスのIPアドレスなど、お客様に関する特定の情報を収集します。「cookie」の詳細については、以下の「cookie」に関する説明をご参照ください
        </p>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    footerIframe() {
      return 'https://勝win.info/iframe/privacy-policy'
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
